import {Component, Input, OnInit} from '@angular/core';
import {TypesService} from '../../services/types.service';
import {FilesService} from '../../services/files.service';
import {Observable} from 'rxjs';
import {PdfToolsService} from '../../services/pdf-tools.service';
import {FormsModule} from '@angular/forms';
import {NgFor} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';

@Component({
  selector: 'fmc-file-viewer',
  templateUrl: './file-viewer.component.html',
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, NgFor, MatCheckboxModule, FormsModule]
})
export class FileViewerComponent implements OnInit {
  @Input() public idt: string;
  @Input() public idv: number;
  public activeDocumentGroup = 'Loan Processing';
  public documentTypes: any;
  public groupedDocumentTypes: any;
  public documentCategories: any;
  public files: any;
  public resultsData: Array<any> = [];
  public selectedFiles: any;

  constructor(public filesService: FilesService,
              public typesService: TypesService,
              public pdfToolsService: PdfToolsService) {
  }

  ngOnInit() {
    if (this.idv && this.idv) {
      this.getTypes().subscribe(() => {
        this.loadFiles();
      });
    }

    this.getSelectedFiles();
  }

  getSelectedFiles() {
    this.pdfToolsService.getFileSelectionData().subscribe((data) => {
      this.selectedFiles = data;
    });
  }

  filterSelectedFiles(files) {
    let i = 0;
    this.files = [];
    files.forEach((file: any) => {
      if (this.selectedFiles && this.selectedFiles.find(x => x._id === file._id)) {
        file.checked = true;
      } else {
        file.checked = false;
      }

      i = i + 1;
      if (files && files.length === i) {
        this.files = files;
      }
    });
  }

  selectFile(file) {
    this.pdfToolsService.sendFileSelectionData(file);
  }

  loadFiles() {
    this.getFilesbyIdentities(this.idv, this.idt);
  }

  changeDocumentCategory(category) {
    this.getSelectedFiles();
    this.activeDocumentGroup = category.text;
    this.files = [];
    this.getFilesbyIdentities(this.idv, this.idt);
  }

  getFilesbyIdentities(idv: number, idt: any, document?: any) {
    const dcs = this.groupedDocumentTypes.find(x => x.name === this.activeDocumentGroup);
    this.filesService.getFiles(idv, idt, null, dcs.types, 1, 30)
      .subscribe((res: any) => {
        this.resultsData = res.filter((r) => r.status !== 'Deleted');
        this.filterSelectedFiles(this.resultsData);
      }, error => {
        console.log(error);
      });
  }

  getTypes(): Observable<any> {
    return new Observable(observer => {
      this.typesService.getTypesList('vx-document-categories')
        .then(
          categories => {
            this.documentCategories = categories;
            this.typesService.getTypesList('vx-document-types')
              .then(types => {
                  this.documentTypes = types;
                  const categoryObject = [];
                  this.documentCategories.forEach(data => {
                    const typesObjects = [];
                    types.forEach(type => {
                      if (type.ext.document_category_id === data.id) {
                        typesObjects.push(type.text);
                      }
                    });
                    categoryObject.push({name: data.text, types: typesObjects});
                  });
                  this.groupedDocumentTypes = categoryObject;

                  observer.next(null);
                  observer.complete();
                },
                error => {
                  console.log(error);
                  observer.error(error);
                });
          },
          error => {
            console.log(error);
          });
    });

  }
}
